import React from 'react';
import statusTypes from '../../status-types';

const colorMap = {};

statusTypes.forEach(el => {
	colorMap[el.code] = el.color;
});

function pinSymbol(color) {
	return {
		path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
		fillColor: color,
		fillOpacity: 1,
		strokeColor: '#333',
		strokeWeight: 1,
		scale: 1,
	};
}

class ListMap extends React.Component {
	map;
	infowindow;
	markers;

	constructor(props) {
		super(props);

		this.map = null;
		this.infowindow = null;
		this.markers = [];
	}

	/* componentDidMount() {
		this.map = new google.maps.Map(this.refs.map, {
			zoom: this.props.zoom,
			center: new google.maps.LatLng(this.props.latitude, this.props.longitude),
			mapTypeId: this.props.mapTypeId === 'satellite' ? google.maps.MapTypeId.SATELLITE : google.maps.MapTypeId.ROADMAP,
		});
		this.setMarkers(this.props.listings);
	} */
	componentDidMount() {
		// creating new script element
		const script = document.createElement('script');
		// This sets the src attribute of the script element to the URL of the Google Maps JavaScript API, including the API key
		script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDGktwxbb0xZmCadduTN59ErIU_TBu4soE&libraries=places`;
		script.async = true;
		script.defer = true;
		script.onload = () => {
			this.initializeMap();
		};
		document.head.appendChild(script);
	}

	initializeMap() {
		this.map = new window.google.maps.Map(this.refs.map, {
			zoom: this.props.zoom,
			center: new window.google.maps.LatLng(this.props.latitude, this.props.longitude),
			mapTypeId: this.props.mapTypeId === 'satellite' ? window.google.maps.MapTypeId.SATELLITE : window.google.maps.MapTypeId.ROADMAP,
			fullscreenControl: this.props.fullscreenControl, // fullscreenControl prop from StriveVision
		});
		this.setMarkers(this.props.listings);
		if (this.props.onLoad) {
			this.props.onLoad(this.map); // Call onLoad function passed from parent
		}
	}

	setMarkers(listings) {
		if (listings && typeof window.google !== 'undefined' && window.google.maps) {
			this.clearMarkers();
			this.markers = listings.filter(el => el.latitude && el.longitude).map(el => {
				const marker = new window.google.maps.Marker({
					position: { lat: parseFloat(el.latitude), lng: parseFloat(el.longitude) },
					map: this.map,
					icon: pinSymbol(colorMap[el.status] || '#F00'),
				});
	
				const infowindow = new window.google.maps.InfoWindow({
					content: `<a href='https://app.strivere.com/property/${el.arcimedes_row_id}' style='display: block; color: inherit;'>
						<div>
							<div><strong>${el.name}</strong></div>
							<div>${el.address}</div>
							<div>${el.city}, ${el.state} ${el.zip}</div>
						</div>
					</a>`
				});
	
				marker.addListener('click', () => {
					if (this.infowindow) {
						this.infowindow.close();
					}
					this.infowindow = infowindow;
					this.infowindow.open(this.map, marker);
				});
	
				return marker;
			});
		} else {
			console.warn("Google Maps API is not loaded yet, skipping marker setup.");
		}
	}
	

	clearMarkers() {
		this.markers.forEach(el => el.setMap(null));
	}


	componentWillReceiveProps(nextProps) {
		if (nextProps.listings !== this.props.listings) {
			this.setMarkers(nextProps.listings);
		}
	}

	shouldComponentUpdate() {
		return false;
	}

	render() {
		return (
			<div ref='map' className='ListMap' />
		);
	}
}

ListMap.defaultProps = {
	latitude: 32.7801399,
	longitude: -96.80045109999998,
	zoom: 4,
	fullscreenControl: true, // Default to true for fullscreen control
};

export default ListMap;